module.exports = __webpack_public_path__ + "img/screenshot_n_36.9e6cbffa.png";